import { FormularioSituacao, ID, InputType, Response } from '../../../../../../_metronic/helpers'
import { AtendimentoForm } from '../../../atendimento_medicos/atendimentos-medico-list/core/_models'
import { FormularioView } from '../../../formularios/formularios-create/core/_models'
import { PacienteList } from '../../../paciente-management/pacientes-list/core/_models'
import {
  FormularioAtendimentoList,
  ListViewContextPropsAvaliacoes,
} from '../../avaliacoes-pendentes-list/core/_models'

export const initialListViewAvaliacoes: ListViewContextPropsAvaliacoes = {
  selected: [],
  onSelect: () => {},
  clearSelected: () => {},
  disabled: false,
  isAllSelected: false,
  onSelectAll: () => {},
}

export type AvaliacoesQueryResponse = Response<Array<FormularioAtendimentoList>>

export type FormularioRespostaList = {
  id: ID
  valor: string
  valores: string[]
  ordem: number
  campo: string
  tipo: InputType
  /** Campo respondido; nulo em resposta anterior à V281. */
  idCampo?: number | null
  /** Código estável do campo respondido; nulo em resposta anterior à V281. */
  codigoCampo?: string | null
  /** Códigos das opções escolhidas em campo RADIO/SELECT; nulo quando não se aplica. */
  codigosOpcao?: string[] | null
}

export type FormularioAtendimentoDto = {
  formularioAtendimento: number
  respostas: { campo: ID; valores: string[] }[]
}

export type FormularioAtendimentoView = {
  respondido: boolean
  concluido: boolean
  respostas: FormularioRespostaList[]
  formulario: FormularioView
  paciente: PacienteList
  situacao: FormularioSituacao
  atendimento: AtendimentoForm
  dataFormatada: string
  id: ID
  data: string
}

export type FormularioAtendimentoDtoAdd = {
  formulario: number
}
